/* globals $, svgedit */
/* jslint vars: true, eqeq: true */
/**
 * Package: svgedit.browser
 *
 * Licensed under the MIT License
 *
 * Copyright(c) 2010 Jeff Schiller
 * Copyright(c) 2010 Alexis Deveria
 */

// Dependencies:
// 1) jQuery (for $.alert())

(function () {
  if (!svgedit.browser) {
    svgedit.browser = {};
  }

  // alias
  const NS = svgedit.NS;

  const supportsSvg_ = (function () {
    return !!document.createElementNS && !!document.createElementNS(NS.SVG, 'svg').createSVGRect;
  }());

  svgedit.browser.supportsSvg = function () { return supportsSvg_; };
  if (!svgedit.browser.supportsSvg()) {
    window.location = 'browser-not-supported.html';
    return;
  }

  const userAgent = navigator.userAgent;
  const svg = document.createElementNS(NS.SVG, 'svg');

  // Note: Browser sniffing should only be used if no other detection method is possible
  const isOpera_ = !!window.opera;
  const isWebkit_ = userAgent.indexOf('AppleWebKit') >= 0;
  const isGecko_ = userAgent.indexOf('Gecko/') >= 0;
  const isIE_ = userAgent.indexOf('MSIE') >= 0;
  const isChrome_ = userAgent.indexOf('Chrome/') >= 0;
  const isWindows_ = userAgent.indexOf('Windows') >= 0;
  const isMac_ = userAgent.indexOf('Macintosh') >= 0;
  const isTouch_ = 'ontouchstart' in window;

  const supportsSelectors_ = (function () {
    return !!svg.querySelector;
  }());

  const supportsXpath_ = (function () {
    return !!document.evaluate;
  }());

  // segList functions (for FF1.5 and 2.0)
  const supportsPathReplaceItem_ = (function () {
    const path = document.createElementNS(NS.SVG, 'path');
    path.setAttribute('d', 'M0,0 10,10');
    const seglist = path.pathSegList;
    const seg = path.createSVGPathSegLinetoAbs(5, 5);

    try {
      seglist.replaceItem(seg, 1);
      return true;
    } catch (err) {}

    return false;
  }());

  const supportsPathInsertItemBefore_ = (function () {
    const path = document.createElementNS(NS.SVG, 'path');
    path.setAttribute('d', 'M0,0 10,10');
    const seglist = path.pathSegList;
    try {
      const seg = path.createSVGPathSegLinetoAbs(5, 5);
      seglist.insertItemBefore(seg, 0);
      return true;
    } catch (err) {}
    return false;
  }());

  // text character positioning (for IE9)
  const supportsGoodTextCharPos_ = (function () {
    const svgroot = document.createElementNS(NS.SVG, 'svg');
    const svgcontent = document.createElementNS(NS.SVG, 'svg');
    document.documentElement.appendChild(svgroot);
    svgcontent.setAttribute('x', 5);
    svgroot.appendChild(svgcontent);
    const text = document.createElementNS(NS.SVG, 'text');
    text.textContent = 'a';
    svgcontent.appendChild(text);
    const pos = text.getStartPositionOfChar(0).x;
    document.documentElement.removeChild(svgroot);
    return (pos === 0);
  }());

  const supportsPathBBox_ = (function () {
    const svgcontent = document.createElementNS(NS.SVG, 'svg');
    document.documentElement.appendChild(svgcontent);
    const path = document.createElementNS(NS.SVG, 'path');
    path.setAttribute('d', 'M0,0 C0,0 10,10 10,0');
    svgcontent.appendChild(path);
    const bbox = path.getBBox();
    document.documentElement.removeChild(svgcontent);
    return (bbox.height > 4 && bbox.height < 5);
  }());

  // Support for correct bbox sizing on groups with horizontal/vertical lines
  const supportsHVLineContainerBBox_ = (function () {
    const svgcontent = document.createElementNS(NS.SVG, 'svg');
    document.documentElement.appendChild(svgcontent);
    const path = document.createElementNS(NS.SVG, 'path');
    path.setAttribute('d', 'M0,0 10,0');
    const path2 = document.createElementNS(NS.SVG, 'path');
    path2.setAttribute('d', 'M5,0 15,0');
    const g = document.createElementNS(NS.SVG, 'g');
    g.appendChild(path);
    g.appendChild(path2);
    svgcontent.appendChild(g);
    const bbox = g.getBBox();
    document.documentElement.removeChild(svgcontent);
    // Webkit gives 0, FF gives 10, Opera (correctly) gives 15
    return (bbox.width == 15);
  }());

  const supportsEditableText_ = (function () {
  // TODO: Find better way to check support for this
    return isOpera_;
  }());

  const supportsGoodDecimals_ = (function () {
  // Correct decimals on clone attributes (Opera < 10.5/win/non-en)
    const rect = document.createElementNS(NS.SVG, 'rect');
    rect.setAttribute('x', 0.1);
    const crect = rect.cloneNode(false);
    const retValue = (crect.getAttribute('x').indexOf(',') == -1);
    if (!retValue) {
      $.alert('NOTE: This version of Opera is known to contain bugs in SVG-edit.\n' +
    'Please upgrade to the <a href="http://opera.com">latest version</a> in which the problems have been fixed.');
    }
    return retValue;
  }());

  const supportsNonScalingStroke_ = (function () {
    const rect = document.createElementNS(NS.SVG, 'rect');
    rect.setAttribute('style', 'vector-effect:non-scaling-stroke');
    return rect.style.vectorEffect === 'non-scaling-stroke';
  }());

  const supportsNativeSVGTransformLists_ = (function () {
    const rect = document.createElementNS(NS.SVG, 'rect');
    const rxform = rect.transform.baseVal;
    const t1 = svg.createSVGTransform();
    rxform.appendItem(t1);
    return rxform.getItem(0) == t1;
  }());

  // Public API

  svgedit.browser.isOpera = function () { return isOpera_; };
  svgedit.browser.isWebkit = function () { return isWebkit_; };
  svgedit.browser.isGecko = function () { return isGecko_; };
  svgedit.browser.isIE = function () { return isIE_; };
  svgedit.browser.isChrome = function () { return isChrome_; };
  svgedit.browser.isWindows = function () { return isWindows_; };
  svgedit.browser.isMac = function () { return isMac_; };
  svgedit.browser.isTouch = function () { return isTouch_; };

  svgedit.browser.supportsSelectors = function () { return supportsSelectors_; };
  svgedit.browser.supportsXpath = function () { return supportsXpath_; };

  svgedit.browser.supportsPathReplaceItem = function () { return supportsPathReplaceItem_; };
  svgedit.browser.supportsPathInsertItemBefore = function () { return supportsPathInsertItemBefore_; };
  svgedit.browser.supportsPathBBox = function () { return supportsPathBBox_; };
  svgedit.browser.supportsHVLineContainerBBox = function () { return supportsHVLineContainerBBox_; };
  svgedit.browser.supportsGoodTextCharPos = function () { return supportsGoodTextCharPos_; };
  svgedit.browser.supportsEditableText = function () { return supportsEditableText_; };
  svgedit.browser.supportsGoodDecimals = function () { return supportsGoodDecimals_; };
  svgedit.browser.supportsNonScalingStroke = function () { return supportsNonScalingStroke_; };
  svgedit.browser.supportsNativeTransformLists = function () { return supportsNativeSVGTransformLists_; };
}());
